<template>
    <article class="a-op-quiz">
        <p class="a-op-quiz__desc">
            {{ desc }}
        </p>
        <a
            class="a-op-quiz__link"
            :href="link.href"
            :title="link.title"
            target="_blank">
            {{ link.text }}
        </a>
    </article>
</template>

<script>
    export default {
        name: 'Quiz',
        data() {
            return {
                desc: 'Если вы хотите принять участие в опросе и получить более подробные ответы, напишите нам!',
                link: {
                    href: 'mailto:pmi@inrso.ru',
                    title: 'Написать о желании пройти опрос',
                    text: 'Пройти опрос'
                }
            }
        }
    }
</script>